<template>
  <ul class="top-bar">
    <li v-for="(item,index) in topBarArr" :key="index" @click="$emit('clickNav',index)">
      <img v-if="index===posIndex" src="../../views/course/images/topselectIcon.png" alt="">
      <span>{{item}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'topBarNav',
  props: {
    posIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      topBarArr: [
        '课程',
        '评价',
        '详情',
      ]
    };
  }
};
</script>

<style scoped lang="stylus">
  .top-bar{
    position: fixed;
    top: 0
    left: 0
    right: 0
    display: flex;
    align-items center
    height: 48px
    background-color white
    z-index: 1999;
    li{
      flex 1
      display: flex;
      justify-content center
      align-items center
      img{
        width: 18px
        height: 18px
        margin-right: 3px
      }
      span{
        font-size:15px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(109,109,128,1);
      }

    }
  }
</style>
